module.exports = __webpack_public_path__ + "static/media/loginLogo.0cce8cb2.png";